import React from 'react';
import useConfig from '../Hooks/useConfig';
import Popup from '../Components/Popup';
import PopupForm from '../Components/AdminPortal/PopupForm';
import WelcomeWhatsNew from '../Components/Home/WelcomeWhatsNew';
import WhatsNewForm from '../Components/AdminPortal/WhatsNewForm';
import NewStaffForm from '../Components/AdminPortal/NewStaffForm';
import EditStaffForm from '../Components/AdminPortal/EditStaffForm';

const defaultPopupConfig = { visible: false, text: "" };
const defaultWhatsNewConfig = { updates: [] };
const defaultStaffConfig = { providers: [], staff: [] };

const AdminPortal = ({ data }) => {
  const {
    config: popupConfig,
    setConfig: setPopupConfig,
    saveConfig: savePopupConfig
  } = useConfig(data.popupConfig || defaultPopupConfig);

  const {
    config: whatsNewConfig,
    setConfig: setWhatsNewConfig,
    saveConfig: saveWhatsNewConfig
  } = useConfig(data.whatsNewConfig || defaultWhatsNewConfig);

  const {
    config: staffConfig,
    setConfig: setStaffConfig,
    saveConfig: saveStaffConfig
  } = useConfig(data.staffConfig || defaultStaffConfig);

  const handleSavePopup = () => savePopupConfig('popupConfig', popupConfig);
  const handleSaveWhatsNew = () => {
    // Save the current state of whatsNewConfig to the database
    saveWhatsNewConfig('whatsNewConfig', whatsNewConfig);
  };
  const handleSaveStaff = () => saveStaffConfig('staffConfig', staffConfig);

  return (
    <div className="flex flex-col gap-4 p-4">
      {/* Row for PopupForm and Popup */}
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex flex-col w-full md:w-1/2 bg-gray-800 p-4 rounded-lg">
          <PopupForm popupConfig={popupConfig} setPopupConfig={setPopupConfig} />
          <button className="mt-4 p-2 bg-blue-500 text-white rounded" onClick={handleSavePopup}>
            Save changes
          </button>
        </div>
        <div className="w-full md:w-1/2 bg-gray-800 p-4 rounded-lg">
          <div className="relative h-full overflow-hidden">
            <Popup
              visible={!!popupConfig?.visible}
              text={popupConfig?.text || ""}
              onClose={() => {}}
              previewMode={true}
            />
          </div>
        </div>
      </div>
      {/* Row for WhatsNewForm and WelcomeWhatsNew */}
      {/* <div className="flex flex-col md:flex-row gap-4"> */}
        <div className="flex flex-col w-full  bg-gray-800 p-4 rounded-lg">
          <WhatsNewForm whatsNewConfig={whatsNewConfig} setWhatsNewConfig={setWhatsNewConfig} />
          <button className="mt-4 p-2 bg-blue-500 text-white rounded" onClick={handleSaveWhatsNew}>
            Save changes
          </button>
        </div>
        {/* <div className="w-full md:w-1/2 bg-gray-800 p-4 rounded-lg">
          <div className="relative h-full overflow-hidden">
            <WelcomeWhatsNew className="hidden" updates={whatsNewConfig.updates} />
          </div>
        </div> */}
      {/* </div> */}
      
      <EditStaffForm staffConfig={staffConfig} setStaffConfig= {setStaffConfig} onSave={handleSaveStaff}/>
      
      <NewStaffForm />
      
    </div>
  );
};

export default AdminPortal;
